import { render, staticRenderFns } from "./MsgAnalysisVideo.vue?vue&type=template&id=efc5e094&"
import script from "./MsgAnalysisVideo.vue?vue&type=script&lang=js&"
export * from "./MsgAnalysisVideo.vue?vue&type=script&lang=js&"
import style0 from "./MsgAnalysisVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports